import { render } from "./CenteredYungoFooter.vue?vue&type=template&id=a6c88046&scoped=true"
import script from "./CenteredYungoFooter.vue?vue&type=script&lang=js"
export * from "./CenteredYungoFooter.vue?vue&type=script&lang=js"

import "./CenteredYungoFooter.vue?vue&type=style&index=0&id=a6c88046&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c88046"]])

export default __exports__